import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { RIGHT_TO_LEFT_LOCALES } from '../../../utils/constants';
import { StoreHeader, TransactionTimeAndPlace } from '../../reusable/ej-view-sections';
import Footer from '../../reusable/ej-view-sections/Footer';
import { ExchangeInTender, ExchangeOutTender } from '../../reusable/ej-view-sections/MediaExchangeTypes/index';

const StoredValueTransactionView = ({
  locale, storeHeaderInfo, timezone, transaction, footers
}) => {
    const isRightToLeft = RIGHT_TO_LEFT_LOCALES.includes(locale.localeName) ? 'RTL' : 'LTR';
  const { RL_DUPLICATERECEIPT, RL_TENDEREXCHANGE } = useSelector((state) => state);
  return (
    <section
      className="p2-sm body-4 flx-jc-sm-c display-print"
      style={{
      direction: isRightToLeft,
      margin: 'auto',
      maxWidth: 275,
      textAlign: 'center'
      }}
    >
      <br />
      <StoreHeader
        address={storeHeaderInfo.address}
        locale={locale}
        localizations={storeHeaderInfo.localizations}
        locationCode={transaction.BusinessUnit?.LocationCode}
        name={storeHeaderInfo.name}
        phoneNumber={storeHeaderInfo.phoneNumber}
        storeConcept={storeHeaderInfo.storeConcept}
        trainingMode={transaction.TrainingModeFlag}
        transaction={transaction}
      />
      <p style={{ fontSize: '16px' }}>{`***${RL_DUPLICATERECEIPT}***`}</p>
      <article className="p2-sm body-4 display-print">
        <p>{RL_TENDEREXCHANGE}</p>
      </article>
      <ExchangeInTender transaction={transaction} />
      <ExchangeOutTender timezone={timezone} transaction={transaction} />
      <TransactionTimeAndPlace
        date={transaction.BusinessDayDate}
        locale={locale}
        operator={transaction.Operator?.ID}
        register={transaction.Workstation?.ID}
        store={transaction.BusinessUnit?.LocationCode}
        suspendedTransactionReference={transaction?.SuspendedTransactionReference}
        time={transaction.EndDateTime}
        timezone={timezone}
        transaction={transaction.SequenceNumber}
      />
      <Footer footers={footers} />
    </section>
  );
};
StoredValueTransactionView.defaultProps = {
  footers: [],
  locale: {},
  storeHeaderInfo: {},
  timezone: '',
  transaction: {},
};

StoredValueTransactionView.propTypes = {
  footers: PropTypes.arrayOf(PropTypes.string),
  locale: PropTypes.shape(),
  storeHeaderInfo: PropTypes.shape(),
  timezone: PropTypes.string,
  transaction: PropTypes.shape(),
};

export default StoredValueTransactionView;
